<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Simple layouts" />
    <div :class="['align-center']">
      <vc-layout :spacing="spacing">
        <vc-col :span="24">
          <div :class="[colDisplay, 'red']">24</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col v-for="i in 2" :span="12" :key="i">
          <div :class="[colDisplay, 'orange']">12</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col v-for="i in 3" :span="8" :key="i">
          <div :class="[colDisplay, 'green']">8</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col v-for="i in 4" :span="6" :key="i">
          <div :class="[colDisplay, 'primary']">6</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col v-for="i in 6" :span="4" :key="i">
          <div :class="[colDisplay, 'light-green']">4</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col v-for="i in 8" :span="3" :key="i">
          <div :class="[colDisplay, 'teal']">3</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col v-for="i in 12" :span="2" :key="i">
          <div :class="[colDisplay, 'cyan']">2</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col v-for="i in 24" :span="1" :key="i">
          <div :class="[colDisplay, 'amber']">1</div>
        </vc-col>
      </vc-layout>
    </div>

    <example-title src="example-2.html" title="Complex layouts" />
    <div :class="['align-center']">
      <vc-layout :spacing="spacing">
        <vc-col :span="4">
          <div :class="[colDisplay, 'red']">4</div>
        </vc-col>
        <vc-col :span="16">
          <div :class="[colDisplay, 'red']">16</div>
        </vc-col>
        <vc-col :span="4">
          <div :class="[colDisplay, 'red']">4</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col :span="5">
          <div :class="[colDisplay, 'orange']">5</div>
        </vc-col>
        <vc-col :span="19" :spacing="spacing">
          <div :class="[colDisplay, 'orange']">19</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col :span="9">
          <div :class="[colDisplay, 'primary']">9</div>
        </vc-col>
        <vc-col :span="6">
          <div :class="[colDisplay, 'primary']">6</div>
        </vc-col>
        <vc-col :span="9">
          <div :class="[colDisplay, 'primary']">9</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col :span="9">
          <div :class="[colDisplay, 'teal']">9</div>
        </vc-col>
        <vc-col :span="3">
          <div :class="[colDisplay, 'teal']">3</div>
        </vc-col>
        <vc-col :span="12">
          <div :class="[colDisplay, 'teal']">12</div>
        </vc-col>
      </vc-layout>
      <vc-layout :spacing="spacing">
        <vc-col :span="11">
          <div :class="[colDisplay, 'light-green']">11</div>
        </vc-col>
        <vc-col :span="11">
          <div :class="[colDisplay, 'light-green']">11</div>
        </vc-col>
        <vc-col :span="2">
          <div :class="[colDisplay, 'light-green']">2</div>
        </vc-col>
      </vc-layout>
    </div>

    <example-title src="example-3.html" title="Breakpoints" />
    <p>Resize the window to observe the breakpoint changes in the grid below. Vuecidity has 5 breakpoints - at
      <span v-for="(breakpoint, index) in breakpoints" :key="index">{{ breakpoint.width }} pixels (<code>{{ breakpoint.name }}(1-24)</code>)<span v-if="index < breakpoints.length - 2">, </span><span v-else-if="index === breakpoints.length - 2"> and </span></span>.</p>
    <ul :class="['breakpoints-list']">
      <li v-for="i in 24" :key="i">
        <code :class="[`font-${breakpoint.color || 'red'}`]">{{ breakpoint.name + i }}</code>
      </li>
    </ul>
    <vc-layout :spacing="spacing" v-resize="resize" :class="['align-center']">
      <vc-col :span="1" v-for="i in 24" :key="i" xs24 sm12 md6 lg2 xl1>
        <div :class="[colDisplay, breakpoint.color || 'red']">{{ breakpoint.name }}: {{ breakpoint.width }}</div>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'LayoutPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      colDisplay: ['col-display', 'elevation-2'],
      spacing: 4,
      breakpoint: null,
      breakpoints: [{
        name: 'xl',
        width: 1920,
        color: 'red'
      }, {
        name: 'lg',
        width: 1440,
        color: 'green'
      }, {
        name: 'md',
        width: 1024,
        color: 'orange'
      }, {
        name: 'sm',
        width: 960,
        color: 'primary'
      }, {
        name: 'xs',
        width: 480,
        color: 'pink'
      }]
    }
  },
  created () {
    this.breakpoint = this.breakpoints[0]
  },
  mounted () {
    this.getPage()
    this.resize()
  },
  methods: {
    resize () {
      const width = this.viewport().width
      const breakpoints = this.breakpoints
      if (width >= 1920) {
        this.breakpoint = breakpoints[0]
      } else if (width >= 1024 && width < 1920) {
        this.breakpoint = breakpoints[1]
      } else if (width >= 960 && width < 1024) {
        this.breakpoint = breakpoints[2]
      } else if (width >= 480 && width < 960) {
        this.breakpoint = breakpoints[3]
      } else if (width <= 480) {
        this.breakpoint = breakpoints[4]
      }
    }
  }
}
</script>
<style>
.col-display
{
  padding: 8px;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
}

.breakpoints-list
{
  padding: 0;
  margin: 0;
  list-style: none;
}

.breakpoints-list li
{
  display: inline-block;
  padding: 8px 4px;
}

.breakpoints-list li:not(:last-child) code::after
{
  content: ' \2022';
}
</style>



// WEBPACK FOOTER //
// src/pages/layout.vue